import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'next-i18next';
import { PerksType } from 'typings/markets/api';
import useMoneyFormat from '@/hooks/useMoneyFormat';
import Spacer from '@/components/ui-components/Spacer';
import Typography from '../../components/Typography';

const useStyles = makeStyles((theme) => ({
  perk: {
    display: 'inline-block',
    backgroundColor: theme.palette.primary.superlight,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    borderRadius: '8px',
    marginTop: theme.spacing(1),
  },
  websiteLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 'bold',
  },
}));

interface Props {
  perks: PerksType;
}

const defaultProps = {};

const Perks = ({ perks }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('markets');
  return (
    <>
      <Typography variant="header">
        {t('markets.detailView.perks.title')}
      </Typography>
      {perks.others?.map((perk) => (
        <>
          <Spacer spacing={2} />
          <Typography variant="base2">{perk.description}</Typography>
        </>
      ))}

      {perks.money_based?.map((perk) => (
        <>
          <Spacer spacing={1} />
          {perk.minimum_amount
            && (
            <div className={classes.perk}>
              <Typography variant="secondaryBold">
                {useMoneyFormat(
                  perk.minimum_amount,
                  'en-US',
                  'USD',
                  'currency',
                  'symbol',
                  0,
                  2,
                ).toUpperCase()}
              </Typography>
            </div>
            )}
          <Spacer spacing={0.5} />
          <Typography variant="base2">{perk.description.charAt(0).toUpperCase() + perk.description.slice(1)}</Typography>
        </>
      ))}
    </>
  );
};

Perks.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default Perks;
